/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'roomplan-hrs': {
    width: 16,
    height: 32,
    viewBox: '0 -1 16 32',
    data: '<metadata id="metadata62"/><path pid="0" class="st1" d="M8.984 16.148v-.247c0-.296-.195-.487-.596-.582l-4.12-1 2.335-.651.024.003 4.401.858c.13.026.222.121.222.234v.337zm3.543-3.618c-.002-.286-.01-.372-.266-.393l-4.845-.566c-.083-.01-.143.022-.143.135v1.627l4.358.792c.186.041.274.164.274.382v.842l-3.54 1.764s-.002-.809 0-.862c0-.187-.066-.365-.263-.426l-4.768-1.24c-.258-.069-.248.14-.248.14v2.3s-.024.204.326.204c.3 0 .275-.203.275-.203v-.18l4.026 1.406v.377s-.016.212.35.212c.318 0 .3-.212.3-.212v-.438l3.583-1.999v.1s-.015.186.313.186c.283 0 .268-.186.268-.186zM14.963 15a6.963 6.963 0 10-13.926 0 6.963 6.963 0 1013.926 0m-.927 0a6.036 6.036 0 11-12.073 0 6.036 6.036 0 0112.073 0" id="path70" _fill="#000" stroke-width=".151"/>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/roomplan-hrs.js